<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5Z"
        stroke="var(--icon-color)" />
    <rect x="4" y="7" width="7" height="1" rx="0.5" fill="var(--icon-color)" />
</svg>

